import { useBlockProps, useInnerBlocksProps } from '@wordpress/block-editor';

export default function Save() {
	const blockProps = useBlockProps.save( {
		className: 'brandy-statement-line',
	} );

	const innerBlocksProps = useInnerBlocksProps.save( {
		className: 'brandy-statement-line__inner',
	} );

	return (
		<div { ...blockProps }>
			<div { ...innerBlocksProps } />
		</div>
	);
}
